/**
 * @fileoverview Model for the identifier of a given override field.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

export class GbpGroup {
  /**
     * @param {{
     *  id: string,
     *  name: string,
     *  locationCount?: number,
     * }} params
     */
  constructor(params) {
    /** @type {string} */
    this.id = params.id;
    /** @type {string} */
    this.name = params.name;
    /** @type {number} */
    this.locationCount = params.locationCount ?? 0;
  }

  /**
     * @param {!GbpGroupJson} json
     * @return {!GbpGroup}
     */
  static fromJSON(json) {
    return new GbpGroup({
      id: json['id'],
      name: json['name'],
    });
  }
}

/**
   * @dict
   * @typedef {{
   *  id: string,
   *  name: string,
   * }}
   */
export let GbpGroupJson;

